const PLACEHOLDER_THUMBNAIL = "https://customer-assets.emergentagent.com/job_content-watch-7/artifacts/thy81wjj_747B42A6-4C25-4A17-A557-B9BBE91C99DB%20Background%20Removed.png";

export const getStoryThumbnailUrl = (story) => story?.thumbnail_url || story?.image_url || PLACEHOLDER_THUMBNAIL;

export const getStoryPhotoCredit = (story) => story?.photo_credit || (story?.author ? `Photo courtesy of ${story.author}` : "");